import { Outlet } from 'react-router-dom';
import { Sidebar } from '@/components/layout/Sidebar';
import { Topbar } from '@/components/layout/Topbar';
import { GuideHelp } from '@/components/GuideHelp';
import { useGlobalAlerts } from '@/hooks/useGlobalAlerts';
import { useUIStore } from '@/stores/uiStore';
import './Layout.scss';

export const Layout = () => {
  // One WS connection for the whole authenticated session — Dashboard,
  // Cameras, and any future route share the same alertsStore feed.
  useGlobalAlerts();

  // Guide/Help modal is app-global so it overlays every route; opened from the
  // sidebar footer button via uiStore.
  const guideOpen = useUIStore((s) => s.guideOpen);
  const closeGuide = useUIStore((s) => s.closeGuide);

  return (
    <div className="app-shell">
      <Sidebar />
      <div className="app-shell__main">
        <Topbar />
        <main className="app-shell__content">
          <Outlet />
        </main>
      </div>
      <GuideHelp open={guideOpen} onClose={closeGuide} />
    </div>
  );
};
